// extracted by mini-css-extract-plugin
module.exports = {"container":"ApprovePaymentModal_container__1sZCb","scroll":"ApprovePaymentModal_scroll__3bWfN"};